module.exports = __webpack_public_path__ + "static/media/61VvLqqe-HL._SX425_.f6f35fd5.jpg";